import request, { gql } from "graphql-request";

export const LOGIN = gql`
 mutation Login($input: LoginInput!) {
  login(input: $input) {
    success
    message
    token
    refreshToken
    username
    email
    userId
role {
      id
      roleName
      permission 
    }


  }
}
`;

export const ForgotPassword = gql`
  mutation SendOTP($email: String!) {
    sendOtpToEmail(email: $email) {
      message
      success
      error
    }
  }
`;

export const OtpVeify = gql`
  mutation VerifyOTP($email: String!, $otp: String!) {
    verifyOtp(email: $email, otp: $otp) {
      message
      success
      error
    }
  }
`;

export const PasswordReset = gql`
  mutation ResetPassword($email: String!, $new_password: String!) {
    resetPassword(email: $email, newPassword: $new_password) {
      message
      success
      error
    }
  }
`;

export const UserLogout = gql`
  mutation Logout($input: LogoutInput!) {
    logout(input: $input) {
      success
      message
      error
    }
  }
`;
